import { render, staticRenderFns } from "./SocialGroup.vue?vue&type=template&id=0998f290&scoped=true&"
import script from "./SocialGroup.vue?vue&type=script&lang=js&"
export * from "./SocialGroup.vue?vue&type=script&lang=js&"
import style0 from "./SocialGroup.vue?vue&type=style&index=0&id=0998f290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0998f290",
  null
  
)

export default component.exports